import { Paper } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import DashboardTotalIndex from "./total-index/DashboardTotalIndex";
import DashboardUnweightedIndex from "./unweighted-Index/DashboardUnweightedIndex";
import DashboardDollarPrice from "./dollar-price/DashboardDollarPrice";
import DashboardOrdersValue from "./orders-value/DashboardOrdersValue";
import DashboardLastClosePrice from "./last-close-price/DashboardLastClosePrice";
import DashboardOptions from "./options/DashboardOptions";
import DashboardCommodityPrice from "./commodity-price/DashboardCommodityPrice";
import DashboardStock from "./stock/DashboardStock";
import DashboardStatusMarket from "./status-market/DashboardStatusMarket";

const Dashboard = () => {
  return (
    <Paper>
      <Grid2 container spacing={2}>
        <Grid2 xs={12} md={6} lg={4}>
          <DashboardTotalIndex />
        </Grid2>
        <Grid2 xs={12} md={6} lg={4}>
          <DashboardUnweightedIndex />
        </Grid2>
        <Grid2 xs={12} lg={4}>
          <DashboardDollarPrice />
        </Grid2>
        <Grid2 xs={12}>
          <DashboardStatusMarket />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <DashboardOrdersValue />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <DashboardLastClosePrice />
        </Grid2>

        <Grid2 xs={12}>
          <DashboardCommodityPrice />
        </Grid2>
        <Grid2 xs={12}>
          <DashboardOptions />
        </Grid2>
        <Grid2 xs={12}>
          <DashboardStock />
        </Grid2>
      </Grid2>
    </Paper>
  );
};

export default Dashboard;
